<template>
  <div class="mp__settings">
    <div class="nav">
      <router-link to="/settings/personal" class="personal">
        <Person />
        <p>Mi información</p>
      </router-link>
    </div>
    <div class="tab">
      <RouterView :user="user" />
    </div>
  </div>
</template>
<script>
import { Person } from '@/assets/icons';
export default {
  components: { Person },
  data() {
    return {
      user: {
        id: 0,
        code: 'CI0090-0003',
        fullName: 'Elena Gonzales Flores',
        documentType: 'DNI',
        document: '70463406',
        address: 'Rodolfo Rutte 287 - Magdalena del Mar',
        phone: 969042613,
        email: 'elenagonzales@gmail.com',
      },
      processors: [
        {
          id: 0,
          code: 'CI0090-0003',
          name: 'Elena',
          lastName: 'Gonzales Flores',
          address: 'Rodolfo Rutte 287 - Magdalena del Mar',
          phone: 969042613,
          email: 'elenagonzales@gmail.com',
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.mp__settings {
  color: #031425;
  p {
    margin-bottom: 0;
  }
  display: flex;
  height: calc(100vh - 67px);
  .nav {
    flex-basis: 20%;
    padding: 0.5rem 0.75rem;
    .personal {
      display: flex;
      gap: 1rem;
      border-radius: 0.5rem;
      padding: 0.75rem 0.5rem;
      background-color: #00e0b1;
      height: fit-content;
      color: #031425;
      font-size: 0.875rem;
      font-weight: 400;
      width: 100%;
      align-items: center;
    }
  }
  .tab {
    flex-basis: 80%;
    background: #fff;
    padding: 2rem 4rem;
  }
}
</style>
